import i18n from "/public/lang/index";

export function getChangeTypeOptions() {
  return [
    { text: i18n.t('hzmbChange.enum.changeType.CHANGE_VEHICLE_DRIVER'), value: 'CHANGE_VEHICLE_DRIVER' },
    { text: i18n.t('hzmbChange.enum.changeType.CHANGE_VEHICLE'), value: 'CHANGE_VEHICLE' },
    { text: i18n.t('hzmbChange.enum.changeType.CHANGE_DRIVER'), value: 'CHANGE_DRIVER' },
  ];
}

export function getChangeTypeText(value) {
  const option = getChangeTypeOptions().find((ele) => ele.value === `${value}`);
  return option && option.text;
}